import React from 'react';
import { useTranslation } from 'react-i18next';
import ConfirmDialog from 'components/UI/Dialog/ConfirmDialog';
import styles from './MBOSWarningPopup.module.scss';

interface MBOSWarningPopupProps {
  isOpen: boolean;
  close: () => void;
}

const MBOSWarningPopup: React.FC<MBOSWarningPopupProps> = (props) => {
  const { isOpen, close } = props;
  const { t } = useTranslation();

  if (!isOpen) {
    return null;
  }
  return (
    <ConfirmDialog close={close} title={t('dialog.MBOSWarning.title')} closeBtnText={t('dialog.close')}>
      <div className={styles.MBOSWarningPopupContent}>
        <p data-testid="MBOS-warning-popup-dialog-paragraph-1">
          {t('dialog.MBOSWarning.line1')}
          <br />
          <br />
          {t('dialog.MBOSWarning.line2')}
          <br />
          <br />
        </p>
        <div dangerouslySetInnerHTML={{ __html: t('dialog.MBOSWarning.line3') }} />
      </div>
    </ConfirmDialog>
  )
};

export default MBOSWarningPopup;
